import React from "react";
import { Box, Typography } from "@mui/material";
import { ActionModule } from "../../../types/actionModule/actionModule";
import {
  ItemCard,
  ItemHeader,
  ItemMeta,
  ColorDot,
  MetaRow,
} from "./EmployeePageWidgets.styles";
import { useTranslation } from "react-i18next";

interface Props {
  module: ActionModule;
}

const ActionModuleItem: React.FC<Props> = ({ module }) => {
  const { t } = useTranslation();
  
  return (
    <ItemCard>
      <ItemHeader>
        <Box display="flex" alignItems="center" gap={1}>
          <ColorDot sx={{ bgcolor: module.colorHex || undefined }} />
          <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
            {module.name}
          </Typography>
        </Box>
      </ItemHeader>

      <ItemMeta>
        <MetaRow>
          <Typography variant="caption">{t("actionPage.maxReward")}</Typography>
          <Typography variant="body2">{module.maxReward ?? "—"}</Typography>
        </MetaRow>

        <MetaRow>
          <Typography variant="caption">{t("actionPage.maxUsers")}</Typography>
          <Typography variant="body2">{module.rewardType ?? "—"}</Typography>
        </MetaRow>
      </ItemMeta>
    </ItemCard>
  );
};

export default ActionModuleItem;
